import React, { useState, useCallback } from 'react';
import { Tabs } from 'antd';
import { VscVariableGroup } from 'react-icons/vsc';
import { FaSliders } from 'react-icons/fa6';
import VariableEditor from "../components/variables/variableeditor.js";
import VolumePricing from "../components/variables/volumepricing.js";
import VariableTable from "../components/variables/variabletable.js";
import './variablesPage.css';


export default function Variables() {
    // State to trigger refresh of VariableTable and store the brand that was updated for flashing
    const [lastUpdatedBrand, setLastUpdatedBrand] = useState(null);
    // State for volume pricing updates
    const [lastVolumeUpdate, setLastVolumeUpdate] = useState(null);

    // Callback to be passed to VariableEditor to update lastUpdatedBrand
    const handleVariableUpdate = useCallback((brandName) => {
        setLastUpdatedBrand(brandName);
    }, []);

    // Callback to be passed to VolumePricing to update lastVolumeUpdate
    const handleVolumeUpdate = useCallback((volumeData) => {
        setLastVolumeUpdate(volumeData);
    }, []);

    const items = [
        {
            key: '1',
            label: (
                <span className="variables-tab-label">
                    <VscVariableGroup size={26} />
                    Variables
                </span>
            ),
            children: (
                <section className='mosaic mosaic-layout-2'>
                    <div className="mosaic-block-2-1">
                        <VariableTable lastUpdatedBrand={lastUpdatedBrand} />
                    </div>

                    <div className="mosaic-block-2-2">
                        <div style={{ position:'sticky', top:'10px', zIndex: '10'}}>
                            <VariableEditor onVariableUpdate={handleVariableUpdate} />
                        </div>
                    </div>

                    <div className="mosaic-block-2-3">
                        <div className='card'>
                            <div className='card-inner'>
                                {/* This block seems empty, maybe for future use */}
                            </div>
                        </div>
                    </div>
                </section>
            ),
        },
        {
            key: '2',
            label: (
                <span className="variables-tab-label">
                    <FaSliders size={26} />
                    Precios por Volumen
                </span>
            ),
            children: (
                <section className='mosaic mosaic-layout-2'>
                    <div className="mosaic-block-2-1">
                        <div style={{ position:'sticky', top:'10px', zIndex: '10'}}>
                            <VolumePricing onVolumeUpdate={handleVolumeUpdate} />
                        </div>
                    </div>

                    <div className="mosaic-block-2-2">
                        <div className='card'>
                            <div className='card-inner'>
                                {/* Empty space for future use */}
                            </div>
                        </div>
                    </div>

                    <div className="mosaic-block-2-3">
                        <div className='card'>
                            <div className='card-inner'>
                                {/* Empty space for future use */}
                            </div>
                        </div>
                    </div>
                </section>
            ),
        },
    ];

    return (
        <>
            <Tabs 
                defaultActiveKey="1" 
                items={items}
                size="large"
                className="variables-page-tabs"
            />
        </>
    )
}